/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_Tab_DietInputs */

const en_features_progress_tab_diet = /** @type {(inputs: Features_Progress_Tab_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const pl_features_progress_tab_diet = /** @type {(inputs: Features_Progress_Tab_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Features_Progress_Tab_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_tab_diet = /** @type {((inputs?: Features_Progress_Tab_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_Tab_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_tab_diet(inputs)
	return en_features_progress_tab_diet(inputs)
});